// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".minting-info-container[data-v-3c3d3cbe] {\n  border: 1px solid var(--v-greyMedium-base);\n}", ""]);
// Exports
module.exports = exports;
